import { useEffect, useState, useRef } from 'react';

function App() {

  const [conversaciones, setConversaciones] = useState([]);
  const [mensajes, setMensajes] = useState([]);
  const [chatActual, setChatActual] = useState('');
  const [nuevoMensaje, setNuevoMensaje] = useState('');
  const mensajesEndRef = useRef(null);

useEffect(() => {

  const cargarConversaciones = async () => {

    const res = await fetch(
      `/api/conversaciones?t=${Date.now()}`
    );

    const data = await res.json();

    setConversaciones(data);

  };

  cargarConversaciones();

  const intervalo = setInterval(
    cargarConversaciones,
    1000
  );

  return () => clearInterval(intervalo);

}, []);

useEffect(() => {

  if (!chatActual) return;

  const cargarMensajes = async () => {

    try {

      const res = await fetch(
        `/api/mensajes/${chatActual}?t=${Date.now()}`
      );

      const data = await res.json();

      console.log('MENSAJES NUEVOS', data);

      setMensajes([...data]);

    } catch (error) {

      console.log(error);

    }

  };

  cargarMensajes();

  const intervalo = setInterval(
    cargarMensajes,
    1000
  );

  return () => clearInterval(intervalo);

}, [chatActual]);

useEffect(() => {

  mensajesEndRef.current?.scrollIntoView({
    behavior: 'smooth'
  });

}, [mensajes]);

const abrirChat = async (conv) => {

  setChatActual(conv.wa_id);

  const res = await fetch(
    `/api/mensajes/${conv.wa_id}`
  );

  const data = await res.json();

  setMensajes([...data]);

};

const finalizarChat = async () => {

  try {

    await fetch('/api/finalizar-chat', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        wa_id: chatActual
      })

    });

    alert('Conversación devuelta al bot 🤖');

  } catch (error) {

    console.log(error);

  }

};

const enviarMensaje = async () => {

  if (!nuevoMensaje.trim()) return;

  await fetch('/api/enviar', {

    method: 'POST',

    headers: {
      'Content-Type': 'application/json'
    },

      body: JSON.stringify({
      wa_id: chatActual,
      mensaje: nuevoMensaje
    })

  });

  setMensajes((prev) => [
  ...prev,
  {
    mensaje: nuevoMensaje,
    origen: 'tecnico',
    fecha: Date.now()
  }
]);

  setNuevoMensaje('');

};

  return (

    <div style={{
      display: 'flex',
      height: '100vh',
      fontFamily: 'Arial'
    }}>

      {/* SIDEBAR */}

      <div style={{
        width: '350px',
        borderRight: '1px solid #ddd',
        background: '#f5f5f5'
      }}>

        <div style={{
          padding: '20px',
          fontSize: '22px',
          fontWeight: 'bold',
          borderBottom: '1px solid #ddd'
        }}>
          CRM tecnológico
        </div>

        {
          conversaciones.map((conv) => (

            <div
              key={conv.id}

              onClick={() => abrirChat(conv)}

              style={{
                padding: '15px',
                borderBottom: '1px solid #ddd',
                cursor: 'pointer',
                background: 'white'
              }}
            >

              <div style={{
                fontWeight: 'bold',
                marginBottom: '5px'
              }}>
                <div style={{
                 display: 'flex',
                 justifyContent: 'space-between',
                 alignItems: 'center'
               }}>

                  <span>
                    {conv.nombre}
                  </span>

                 <span style={{
                     fontSize: '12px',
                     padding: '3px 8px',
                     borderRadius: '10px',
                     background:
                     conv.modo_visual === 'tecnico'
                      ? '#ff4d4f'
                      : '#25d366',

                       color: 'white'
                        }}>
                     {
                      conv.modo_visual === 'tecnico'
                     ? 'HUMANO'
                     : 'BOT'
                 }
                    </span>

                    </div>
              </div>

              <div style={{
                color: '#555',
                fontSize: '14px'
              }}>
                {conv.ultimo_mensaje}
              </div>

            </div>

          ))
        }

      </div>

              {/* CHAT */}
             <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              overflow: 'hidden'
             }}>
        {
          chatActual ? (
             <div style={{
               flex: 1,
               display: 'flex',
               flexDirection: 'column',
               minHeight: 0
                }}>

              <div style={{
                padding: '20px',
                background: '#f0f2f5',
                borderBottom: '1px solid #ddd',
                fontWeight: 'bold'
              }}>
                  {
                    conversaciones.find(
                     c => c.wa_id === chatActual
                  )?.nombre
                  }

                  <button
                   onClick={finalizarChat}
                    style={{
                    marginLeft: '20px',
                    padding: '8px 15px',
                    border: 'none',
                    borderRadius: '8px',
                    background: '#ff4d4f',
                    color: 'white',
                    cursor: 'pointer'
                     }}
                    >
                       Finalizar atención
                    </button>

                     </div>
  
                     <div style={{
                        flex: 1,
                        minHeight: 0,
                        padding: '20px',
                        overflowY: 'auto',
                        background: '#ece5dd',
                        display: 'flex',
                        flexDirection: 'column'
                            }}>

                     {
                      mensajes
                      .filter(msg => msg.mensaje && msg.mensaje.trim() !== '')
                      .map((msg) => (

                    <div
                      key={`${msg.id}-${msg.fecha}`}
                     
                      style={{
                        display: 'flex',
                        justifyContent:
                          msg.origen === 'tecnico'
                            ? 'flex-end'
                            : 'flex-start',

                        marginBottom: '10px'
                      }}
                    >

                      <div style={{
                       background:
                         msg.origen === 'tecnico'
                         ? '#d9fdd3'
                          : 'white',

                        padding: '10px',
                        borderRadius: '10px',
                        maxWidth: '300px'
                           }}>

                        {msg.tipo === 'image' ? (

                         <img
                          src={msg.archivo}
                          alt="Imagen"
                          style={{
                          maxWidth: '250px',
                          borderRadius: '10px'
                           }}
                            />

                           ) : (

                            msg.mensaje

                           )}

                    </div>
                    </div>

                  ))
                }
                <div ref={mensajesEndRef} />
                </div>

                <div style={{
                padding: '15px',
                borderTop: '1px solid #ddd',
                display: 'flex',
                gap: '10px',
                background: 'white',
                marginTop: 'auto'
                }}>

               <input

               value={nuevoMensaje}

                onChange={(e) =>
               setNuevoMensaje(e.target.value)
               }

               placeholder="Escribe un mensaje"

               style={{
               flex: 1,
               padding: '10px',
               borderRadius: '10px',
               border: '1px solid #ccc'
                } }
               />
              
               <button

                onClick={enviarMensaje}

                style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '10px',
                background: '#25d366',
                color: 'white',
                cursor: 'pointer'
               }}
             >
              Enviar
             </button>

              </div>

            </div>

          ) : (

            <div style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#666',
              fontSize: '30px'
            }}>
             Selecciona una conversación
            </div>

          )
        }

      </div>

    </div>

  );

}

export default App;